import { useEffect, useState } from 'react';

import axios from 'axios';
import Flatpickr from 'react-flatpickr';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Card, CardBody, CardHeader, Col, Input, Row } from 'reactstrap';
import {
  CREATE_SURGE_RULE_EMPTY,
  CREATE_SURGE_WORKFLOW,
  CREATE_SURGE_WORKFLOW_EMPTY,
  CREATE_TEMPLATE_WORKFLOW,
  RULE_DETAILS,
} from '../../../../../../../../store/actions';
import { Error, Loader } from '../../../../../../../Common';
import { customHeaders, thriweDiscoveryUrl } from '../../../../../../../Config';
import { Constant } from '../../../../../../../Helpers/constant';
import CreateRuleModal from '../../../../Event/CreateEvent/Components/Modal';

const CreateSurgeWorkflowForm = () => {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const initialState = {
    name: '',
    trigger: {
      frequency: 0,
      isfrequencyEnabled: false,
    },
    effects: [
      {
        effect: null,
        value: '',
      },
    ],
    expression: '',
    rule: null,
    isAggregationEnabled: false,
    agreegatorType: null,
    agreegatorOperator: null,
  };

  const [state, setState] = useState(initialState);
  const [isValidationShow, setIsValidationShow] = useState(false);

  console.log('State', state);

  const [loading, setLoading] = useState(false);
  const [isCreateRuleModal, setIsCreateRuleModal] = useState(false);

  /* ---------------------------- REDUX STATES ---------------------------- */
  // CREATE SURGE RULE
  const { createSurgeRule, createSurgeRuleLoading } = useSelector(state => ({
    createSurgeRule: state?.CreateSurgeRule?.data,
    createSurgeRuleLoading: state?.CreateSurgeRule?.loading,
  }));

  // CREATE SURGE WORKFLOW
  const { createTemplateWorkflow, createTemplateWorkflowLoading } = useSelector(state => ({
    createTemplateWorkflow: state?.CreateTemplateWorkflow?.data,
    createTemplateWorkflowLoading: state?.CreateTemplateWorkflow?.loading,
  }));

  // Rule Details
  const { ruleDetails, ruleDetailsLoading } = useSelector(state => ({
    ruleDetails: state?.RuleDetails?.data,
    ruleDetailsLoading: state?.RuleDetails?.loading,
  }));

  useEffect(() => {
    if (createSurgeRule !== null) {
      dispatch({
        type: CREATE_SURGE_RULE_EMPTY,
      });
      dispatch({
        type: RULE_DETAILS,
        payload: {
          data: {
            ruleId: createSurgeRule?.rule_id,
          },
        },
      });
      setIsCreateRuleModal(false);
    }
  }, [createSurgeRule]);

  console.log('rule', state);

  useEffect(() => {
    if (ruleDetails !== null) {
      setState({
        ...state,
        rule: {
          value: ruleDetails?.rule_id,
          label: ruleDetails?.name,
          completeData: {
            name: ruleDetails?.name,
            rule_id: ruleDetails?.rule_id,
            table_name: ruleDetails?.table_name,
            conditions: [
              {
                CreatedAt: ruleDetails?.created_at,
                rule_id: ruleDetails?.rule_id,
                operator: ruleDetails?.where?.[0]?.operator,
                column_name: ruleDetails?.where?.[0]?.column,
                value: ruleDetails?.where?.[0]?.value,
              },
            ],
            created_at: ruleDetails?.created_at,
            message: 'Rule details fetched successfully',
          },
        },
      });
    }
  }, [ruleDetails]);

  useEffect(() => {
    if (createTemplateWorkflow !== null) {
      dispatch({
        type: CREATE_SURGE_WORKFLOW_EMPTY,
      });

      setState({ ...initialState });
    }
  }, [createTemplateWorkflow]);

  /* ---------------------------- INPUT CHANGE HANDLER ---------------------------- */
  const inputChangeHandler = e => {
    const { name, value } = e.target;
    let updatedState = { ...state };

    switch (name) {
      case 'effect-value':
        updatedState = {
          ...state,
          effects: [
            {
              ...state?.['effects']?.[0],
              value: value,
            },
          ],
        };
        break;

      case 'isfrequencyEnabled':
        updatedState = {
          ...state,
          trigger: {
            ...state?.trigger,
            isfrequencyEnabled: !state?.trigger?.isfrequencyEnabled,
          },
        };
        break;

      case 'isAggregationEnabled':
        updatedState = {
          ...state,
          isAggregationEnabled: !state?.isAggregationEnabled,
        };
        break;

      case 'name':
        updatedState = {
          ...state,
          name: value,
        };
        break;

      default:
      // do nothing
    }

    setState(updatedState);
    validateErrors(`validationCheck`, updatedState);
  };

  /* ---------------------------- INPUT SELECT HANDLER ---------------------------- */
  const inputSelectHandler = (label, data) => {
    if (label === 'rule' && data?.value === 'add_rule') {
      console.log('CHeck Here');
      setIsCreateRuleModal(true);
      return;
    }
    let updatedState = { ...state };

    switch (label) {
      case 'event':
        updatedState = {
          ...state,
          events: [
            {
              ...state?.events?.[0],
              event: data,
            },
          ],
        };
        break;

      case 'rule':
        updatedState = {
          ...state,
          rule: data,
        };
        break;

      case 'effect':
        updatedState = {
          ...state,
          effects: [
            {
              ...state?.['effects']?.[0],
              effect: data,
            },
          ],
        };
        break;

      case 'frequency':
        updatedState = {
          ...state,
          trigger: {
            ...state?.trigger,
            frequency: data,
          },
        };
        break;

      default:
      // do nothing
    }

    setState(updatedState);
    validateErrors(updatedState, `validationCheck`);
  };

  /* ---------------------------- VALIDATION CHECK ---------------------------- */
  const validateErrors = (data = state, flag) => {
    if (data?.name !== `` && data?.rule !== null && data?.effects?.[0]?.effect !== null && data?.effects?.[0]?.value?.trim() !== '') {
      setIsValidationShow(false);
      return true;
    } else {
      setIsValidationShow(flag === `submissionCheck` ? true : isValidationShow);
      return false;
    }
  };

  /* ---------------------------- SUBMIT HANDLER ---------------------------- */
  const submitHandler = () => {
    console.log('check', validateErrors(state, `submissionCheck`));
    if (validateErrors(state, `submissionCheck`)) {
      const payload = {
        name: state?.name,
        trigger: {
          frequency: parseInt(state?.trigger?.frequency ?? 0),
        },
        expression: `${state?.rule?.value}`,
        effects: [
          {
            effect_type_id: state?.effects?.[0]?.['effect']?.['value'],
            value: parseInt(state?.effects?.[0]?.['value'] ?? 0),
          },
        ],
        rules: [
          {
            id: `${state?.rule?.value}`,
          },
        ],
      };

      dispatch({
        type: CREATE_TEMPLATE_WORKFLOW,
        payload: {
          data: {
            ...payload,
          },
        },
      });
    }
  };

  /* ---------------------------- LOADING HANDLER ---------------------------- */
  useEffect(() => {
    if (createTemplateWorkflowLoading || ruleDetailsLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [createTemplateWorkflowLoading, ruleDetailsLoading]);

  return (
    <>
      {isCreateRuleModal && (
        <CreateRuleModal
          isLoading={createSurgeRuleLoading}
          onClose={() => {
            setIsCreateRuleModal(false);
          }}
        />
      )}
      {loading && <Loader />}

      <Card className="card-inner">
        {/* <button onClick={() => console.log('hello get state', state)}>get State</button>
        <button onClick={() => setIsCreateRuleModal(true)}>Create rule</button> */}

        <CardHeader className="d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Template</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col md={4}>
              <Input
                id="name"
                name="name"
                type="text"
                className="form-control"
                value={state?.name}
                onChange={inputChangeHandler}
                placeholder="Enter Template Name"
                autoComplete="off"
              />
              {isValidationShow && state?.name === '' && <Error text="Please enter template name" />}
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card className="card-inner">
        <CardHeader className="d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Rules</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm={4} className="mb-3">
              <AsyncPaginate
                debounceTimeout={500}
                value={state?.rule}
                loadOptions={loadSurgeRules}
                onChange={event => inputSelectHandler('rule', event)}
                isMulti={false}
                closeMenuOnSelect={true}
                noOptionsMessage={() => 'No results found'}
                cacheUniqs={[['code']]}
                placeholder="Select Rule"
              />
              {isValidationShow && state?.rule === null && <Error text="Please select rule" />}
            </Col>

            <>
              <Col sm={4} className="mb-3">
                <Select
                  id="rule-table"
                  name="rule-table"
                  placeholder="Select Table"
                  value={
                    state?.rule
                      ? {
                          value: `${state?.rule?.['completeData']?.['table_name']}`,
                          label: `${state?.rule?.['completeData']?.['table_name']}`,
                        }
                      : null
                  }
                  isDisabled={true}
                />
              </Col>

              <Col sm={4} className="mb-3">
                <Select
                  id="rule-column"
                  name="rule-column"
                  placeholder="Select Column"
                  value={
                    state?.rule
                      ? {
                          value: `${state?.rule?.['completeData']?.['conditions']?.[0]?.['column_name']}`,
                          label: `${state?.rule?.['completeData']?.['conditions']?.[0]?.['column_name']}`,
                        }
                      : null
                  }
                  isDisabled={true}
                />
              </Col>

              <Col sm={4} className="mb-3">
                <Select
                  id="rule-operator"
                  name="rule-operator"
                  placeholder="Select where operator"
                  value={
                    state?.rule
                      ? {
                          value: `${state?.rule?.['completeData']?.['conditions']?.[0]?.['operator']}`,
                          label: `${state?.rule?.['completeData']?.['conditions']?.[0]?.['operator']}`,
                        }
                      : null
                  }
                  isDisabled={true}
                />
              </Col>

              <Col sm={4} className="mb-3">
                <Input
                  type="text"
                  id="rule-value"
                  name="rule-value"
                  placeholder="Value"
                  className="form-control"
                  value={state?.rule ? `${state?.rule?.['completeData']?.['conditions']?.[0]?.['value']}` : ''}
                  disabled={true}
                />
              </Col>
            </>
          </Row>
          <Row>
            <Col md={3}>
              <div className="mb-3">
                <div className="d-flex align-items-center">
                  {/* <span className="text-muted me-3">Aggregation Allowed</span> */}
                  {/* <div className="form-switch d-inline-block ">
                    <Input
                      className="form-check-input code-switcher form-switch-md cursor-pointer"
                      type="checkbox"
                      id="isAggregationEnabled"
                      name="isAggregationEnabled"
                      checked={state?.isAggregationEnabled}
                      onChange={inputChangeHandler}
                    />
                  </div> */}
                </div>
              </div>
            </Col>
          </Row>
          {state?.isAggregationEnabled && (
            <Row>
              <Col md={4}>
                <div className="mb-3">
                  <Select
                    id="agreegation-type"
                    name="agreegation-type"
                    options={[]}
                    value={state.agreegatorType}
                    onChange={data => inputSelectHandler(`agreegation-type`, data)}
                    placeholder="Aggregator Type"
                  />
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Select
                    id="agreegation-operator"
                    name="agreegation-operator"
                    options={[]}
                    value={state.agreegatorOperator}
                    onChange={data => inputSelectHandler(`agreegation-operator`, data)}
                    placeholder="Aggregator Operator"
                  />
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Input
                    name="value"
                    type="text"
                    className="form-control"
                    value={state.value}
                    onChange={inputChangeHandler}
                    autoComplete="off"
                    placeholder="Value"
                  />
                </div>
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>

      <Card className="card-inner">
        <CardHeader className="d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Frequency</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col md={3}>
              <div className="mb-3">
                <div className="d-flex align-items-center">
                  <span className="text-muted me-3">Frequency</span>
                  <div className="form-switch d-inline-block ">
                    <Input
                      className="form-check-input code-switcher form-switch-md cursor-pointer"
                      type="checkbox"
                      id="isfrequencyEnabled"
                      name="isfrequencyEnabled"
                      checked={state?.trigger?.isfrequencyEnabled}
                      onChange={inputChangeHandler}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Select
                id="frequency-unit"
                name="frequency-unit"
                value={{
                  value: 'Minutes',
                  label: 'Minutes',
                }}
                options={[
                  {
                    value: 'Minutes',
                    label: 'Minutes',
                  },
                ]}
                isDisabled={!state?.trigger?.isfrequencyEnabled}
              />
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <div className="my-3">
                <div className="d-flex align-items-center">
                  <span className="text-muted me-3">Every</span>
                  <div className="">
                    <select
                      className="form-control"
                      value={state?.trigger?.frequency}
                      onChange={e => inputSelectHandler(`frequency`, e.target.value)}
                      disabled={!state?.trigger?.isfrequencyEnabled}
                    >
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                    </select>
                  </div>
                  <span className="text-muted ms-3">Minute(s)</span>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card className="card-inner">
        <CardHeader className="d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Effects Configuration</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col md={4}>
              <AsyncPaginate
                debounceTimeout={500}
                value={state?.['effects']?.[0]?.['effect']}
                loadOptions={loadSurgeEffects}
                onChange={event => inputSelectHandler(`effect`, event)}
                isMulti={false}
                closeMenuOnSelect={true}
                noOptionsMessage={() => 'No results found'}
                cacheUniqs={[['code']]}
                placeholder="Select Effect"
              />
              {isValidationShow && state?.['effects']?.[0]?.['effect'] === null && <Error text="Please select effect" />}
            </Col>

            <Col sm={4} className="mb-3">
              <Input
                type="number"
                className="form-control"
                id="effect-value"
                name="effect-value"
                placeholder="Value"
                value={state?.['effects']?.[0]?.['value']}
                onChange={inputChangeHandler}
              />
              {isValidationShow && state?.['effects']?.[0]?.['value'] === '' && <Error text="Please enter effect value" />}
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Col md={12} className="mb-5">
        <div className="text-end">
          <button type="submit" className="btn btn-primary btn-lg" onClick={submitHandler}>
            Create Workflow
          </button>
        </div>
      </Col>
    </>
  );
};

export default CreateSurgeWorkflowForm;

/* ---------------------------- GET RULES LIST  ---------------------------- */

async function loadSurgeRules(search) {
  let urlParam = null;

  return await axios({
    method: `GET`,
    url: `${thriweDiscoveryUrl}/v1/admin/list-rules`,
    headers: {
      Authorization: Constant?.CLIENT_TOKEN,
      ...customHeaders,
    },
    params: {
      ...urlParam,
      name: search === '' ? null : search,
      skip: 0,
      limit: 150,
    },
  })
    .then(response => {
      let ruleOptions = response?.data?.results?.map(data => ({
        value: data?.rule_id,
        label: `${data?.name}`,
        completeData: data,
      }));

      // Add the "Add Rules" option at the top
      return {
        options: [
          { value: 'add_rule', label: <span style={{ cursor: 'pointer !important', fontWeight: 'medium' }}>➕ Add Rules</span>, isCustom: true },
          ...ruleOptions,
        ],
        hasMore: false,
      };
    })
    .catch(err => {
      return err;
    });
}

/* ---------------------------- GET EFFECTS LIST  ---------------------------- */
async function loadSurgeEffects(search) {
  let urlParam = null;

  return await axios({
    method: `GET`,
    url: `${thriweDiscoveryUrl}/v1/admin/list-event-effects`,
    headers: {
      Authorization: Constant?.CLIENT_TOKEN,
      ...customHeaders,
    },
    params: {
      ...urlParam,
      name: search === '' ? null : search,
      skip: 0,
      limit: 150,
    },
  })
    .then(function (response) {
      return {
        options: response?.data?.results?.map(data => {
          return {
            value: data?.id,
            label: `${data?.name}`,
            completeData: data,
          };
        }),
        hasMore: false,
      };
    })
    .catch(err => {
      return err;
    });
}
